import {
    GET_PAGOS_APROBADOS,
    GET_ESTADO_EMISION_PAGOS,
    POST_EMITE_PAGOS
} from '../types';

export default function emisionPagosReducer(state = {}, action) {
    if (action.error) return state

    switch (action.type) {
        case GET_PAGOS_APROBADOS:
            return { ...state, pagosAprobados: action.payload }
        case GET_ESTADO_EMISION_PAGOS:
            return { ...state, estadoEmision: action.payload }
        case POST_EMITE_PAGOS:
            return { ...state, emisionRealizada: action.payload }
        default:
            return state
    }
}
